import { Popup, ActionSheet, Cell, CellGroup, Field, DatetimePicker, Radio } from 'vant'
import { mapState } from 'vuex'

export default {
  components: {
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Radio.name]: Radio
  },
  props: {
    visibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState({
      empInfo: state => state.app.userInfo.empInfo
    })
  },
  methods: {
    save () {
      let params = {
        'birthPlace': this.empInfo.birthPlace, //出生地
        'born': this.empInfo.born,
        'email': this.empInfo.email, //邮箱
        'engName': this.empInfo.engName,
        'idNumber': this.empInfo.idNumber, //身份证号码
        'nation': this.empInfo.nation,
        'oldIdNumber': this.oldIdNumber, //电话号
        'passport': this.empInfo.passport, // 护照号码
        'passportPeriod': this.empInfo.passportPeriod, //护照有效期
        'phoneNumber': this.empInfo.phoneNumber, //手机号
        'placeOfIssue': this.empInfo.placeOfIssue, //签发地
        'preference': this.empInfo.preference, // 个人偏好 ,
        'sex': this.empInfo.sex,
        civilBankId: this.empInfo.civilBankId,
        civilBankName: this.empInfo.civilBankName,
        civilCheck: this.empInfo.civilCheck,
        isCivil: this.empInfo.isCivil,
        unitAddress:this.empInfo.unitAddress
      }

      this.$api['user/vipEmpEditInfoObt'](params).then(() => {
        this.$dialog.alert({ message: '修改成功' }).then(() => {
          this.isShow = false
        })
      })
    }
  },
  watch: {
    visibility (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
}